{
  "GenericFooter_ServerErrorTitle": "Validierungsfehler",
  "GenericFooter_ValidationWarning": "Bitte stellen Sie sicher, dass alle Felder korrekt ausgefüllt sind",
  "GenericFooter_ButtonHelpLabel": "Helfen?",
  "GenericFooter_ButtonSubmitLabel": "Speichern Sie",
  "GenericFooter_ButtonCancelLabel": "Abbrechen",
  "NAME": "GenericFooter"
}